<template>
    <div ref="dropZoneElement">
        <div class="formItem" :class="{'formError' : error}">
            <label>{{ label }}
                <span v-if="subLabel"> ({{ subLabel }})</span>
            </label>
            <span v-if="localValue.length === 0 && isDisabled === true">
                Keine Daten vorhanden
            </span>
            <ul class="entry-list" v-show="localValue.length">
                <li class="icon-document" v-for="(file, index) in localValue" :key="file.id">
                    <a href="#" title="#" class="icon-trash-small" v-if="!readonly && !loading" @click.stop.prevent="removeFile(index)"></a>
                    <!--<v-progress-circular :size="16" :width="2" color="#2ED1DF" indeterminate></v-progress-circular>-->
                    <a v-if="getFileUrl(file)" :href="getFileUrl(file)" target="_blank" class="link">{{ getFileTitle(file) }}</a>
                    <span v-if="!getFileUrl(file)">{{ getFileTitle(file) }}</span>
                </li>
            </ul>
        </div>
        <div class="formItem" v-if="!readonly" :class="{'formError' : error}">
            <div class="droparea">
                <i class="icon-plus"></i>
                Dateien hier ablegen
            </div>
        </div>
    </div>
</template>
<script>
  import Dropzone from 'dropzone'

  Dropzone.autoDiscover = false
  export default {
    props: {
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        dropzone: null,
        dropzoneSettings: {
          uploadMultiple: true,
          parallelUploads: 1
        }
      }
    },
    mounted () {
      if (this.readonly) {
        return
      }
      this.dropzone = new Dropzone(this.$refs.dropZoneElement, this.getDropZoneSettings)
      this.dropzone.on('addedfile', (file) => {
      }).on('complete', (file) => {
        if (typeof file.xhr !== 'undefined' && typeof file.xhr.response !== 'undefined') {
          let r = JSON.parse(file.xhr.response)
          if (r.status === 'ok') {
            for (let i = 0; i < r.tmpFiles.length; i++) {
              this.localValue.push({
                hash: r.tmpFiles[i],
                uuid: file.upload.uuid
              })
            }
          }
        }
        this.valueChanged()
      }).on('error', (file) => {
        if (!file.accepted) {
          this.dropzone.removeFile(file)
        }
      })
    },
    beforeDestroy () {
      if (this.dropzone) {
        this.dropzone.destroy()
      }
    },
    methods: {
      valueChanged () {
        this.$emit('input', this.localValue)
      },
      removeFile (index) {
        this.localValue.splice(index, 1)
        this.valueChanged()
      },
      getFileUrl (file) {
        if (file.url) {
          return file.url
        }
        /*
        if (this.dropzone && this.dropzone.files && file.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === file.uuid)
          return obj.dataURL
        }
*/
        return ''
      },
      getFileTitle (file) {
        if (file.title) {
          return file.title
        }
        if (this.dropzone && this.dropzone.files && file.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === file.uuid)
          return obj.name
        }
        return ''
      }
    },
    computed: {
      isDisabled () {
        return this.readonly === true || this.disabled === true || this.loading === true
      },
      localValue: {
        get () {
          return this.value || []
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      getDropZoneSettings () {
        let settings = this.dropzoneSettings
        settings.url = process.env.VUE_APP_API_ENDPOINT + 'file/upload'
        settings.headers = { 'X-Session-Id': this.$store.getters['auth/getSessionId'] }
        settings.clickable = [this.$el.querySelector('.droparea')]
        settings.previewsContainer = false
        return settings
      }
    }
  }
</script>
